import {FC} from 'react';

import styles from './GridHeader.module.css';

type Props = {};
export const GridHeader: FC<Props> = () => {
    return (
        <div className={styles.block}>
            <div className={styles.item}>Наименование</div>
            <div className={styles.item}>Цена</div>
            <div className={styles.item}>Количество</div>
            <div className={styles.item}>Сумма</div>
        </div>
    );
};
